import React from 'react';


export default class RssFeed extends React.Component {

    render() {
        const showDescription = typeof this.props.showDescription == 'undefined' ? true : this.props.showDescription;
        return (
            <div className="rss-feed">
                {this.props.entries.map(function (item, index) {
                    return (
                        <a key={index} className="rss-feed__item" href={item.link}>
                            <div className="rss-feed__title">{item.title}</div>
                            {showDescription &&
                            <div className="rss-feed__description">{item.description}</div>}
                        </a>
                    );
                }.bind(this))}
            </div>
        );
    }

}